module.exports = __webpack_public_path__ + "static/img/tit07.5ca8e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tit07.png
// module id = /MTE
// module chunks = 0